import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
  ItemContainer,
  ImageComtainer,
  InfoComtainer,
  InfoTitle,
} from './style';
import Detail from './Detail';
import unit_institution from "../../../store/asset_institution/unit_institution";
import unit_institution_promotion from "../../../store/asset_institution/unit_institution_promotion";
import { webviewRedirect } from '../../../utils/tool';

class AuctionItem extends Component {
  static propTypes = {
    itemInfo: PropTypes.object,
  };

  static defaultProps = {
    itemInfo: {},
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
  }

  gotoItemPage(paimaiId) {
    // 跳转推介单品页同时写入缓存
    const {setTabIndex} = unit_institution;
    const {setAssetPromotionData} = unit_institution_promotion;
    setAssetPromotionData();
    setTabIndex();
    webviewRedirect(`//mauction.jd.com/zichan/tuijie/index.html#/detail/${paimaiId}`)
  }

  render() {
    const {itemInfo} = this.props;
    const {merchantsStatus,mainImgUrl,id,name} = this.props.itemInfo;
    const MAP_MERCHANTS_STATUS = {
      1: {
        TEXT:'招商中'
      },
      2: {
        TEXT:'已转竞价'
      },
      3: {
        TEXT:'招商结束'
      },
      4: {
        TEXT:'已关闭'
      }
    };
    return (
      <ItemContainer onClick={() => {
        this.gotoItemPage(id);
      }}>
        <ImageComtainer>
          <i className={`icon-corner-sign ${merchantsStatus === 3 || merchantsStatus === 4?'over':''}`}>{merchantsStatus && MAP_MERCHANTS_STATUS[merchantsStatus].TEXT}</i>
          <img src={`//m.360buyimg.com/paimai/s320x214_${mainImgUrl}!q85!cc_320x214`}/>
        </ImageComtainer>
        <InfoComtainer>
          <InfoTitle>{name}</InfoTitle>
          <Detail itemInfo={itemInfo}></Detail>
        </InfoComtainer>
      </ItemContainer>
    )
  }
}

export default AuctionItem;
